import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Variables {
	contactId: string;
	tags: string[];
}

export function useContactTagsUpdateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IContact, variables: Variables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ contactId, tags }: Variables) => {
			return userSession.webServiceHelper.callAsync<Api.IContact>(`contact/${contactId}/tags`, 'PUT', tags);
		},
		onSuccess,
		onError,
	});
}
